<template>
  <v-container class="py-8 bg-light-blue-main">
    <h1>{{ $t("views.main.user-spaces") }}</h1>
    <div class="d-flex flex-row ga-8 flex-wrap">
      <div
        v-for="space in privateSpaces"
        :key="space.id">
        <SpaceCard
          :space="space"
          @edit-space="() => editSpace(space.id)"></SpaceCard>
      </div>

      <div>
        <v-card @click="spaceCreateDialog = true">
          <v-card-title>{{ $t("views.main.new-space") }}</v-card-title>
          <v-card-subtitle></v-card-subtitle>
        </v-card>
      </div>
    </div>

    <template v-if="teamSpaces.length > 0"
      ><h1>{{ $t("views.main.team-spaces") }}</h1>
      <div class="d-flex flex-row ga-8 flex-wrap">
        <div
          v-for="space in teamSpaces"
          :key="space.id">
          <SpaceCard
            :space="space"
            @edit-space="() => editSpace(space.id)"></SpaceCard>
        </div></div
    ></template>

    <v-dialog v-model="spaceEditDialog">
      <SpaceEdit
        :space-id="spaceEditId"
        @close="spaceEditDialog = false" />
    </v-dialog>

    <v-dialog v-model="spaceCreateDialog">
      <SpaceCreate @close="spaceCreateDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/mainStore";
import { computed, ref } from "vue";
import SpaceEdit from "@/components/dialogs/SpaceEdit.vue";
import SpaceCreate from "@/components/dialogs/SpaceCreate.vue";
import SpaceCard from "./Space/SpaceCard.vue";

const mainStore = useMainStore();

const spaceEditDialog = ref(false);
const spaceEditId = ref(null);
const spaceCreateDialog = ref(false);

const privateSpaces = computed(() => {
  return mainStore.calculationSpaces.filter((space) => !space.organization);
});

const teamSpaces = computed(() => {
  return mainStore.calculationSpaces.filter((space) => space.organization);
});

const editSpace = (spaceId: number) => {
  spaceEditId.value = spaceId;
  spaceEditDialog.value = true;
};
</script>

<style scoped lang="scss">
.v-card {
  width: 400px;
  height: 400px;
}
</style>
